import React from "react";
import {
  Tabs,
  Tab,
  Box,
  Paper,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LockResetIcon from "@mui/icons-material/LockReset";
import BankerAccount from "./bankerAccount";
import BankerChangePassword from "./bankerChangePassword";
import {getLoginUserData} from "../../../services/account.service";
import Loader from "../../../common/loader";

const BankerProfile: React.FC = () => {
  const [activeTab, setActiveTab] = React.useState(0);
  const [bankerId, setBankerId] = React.useState("");
  const [loading, setLoading] = React.useState(true);
  const [loggedInUserId, setLoggedInUserId] = React.useState("");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  React.useEffect(() => {
    const init = async () => {
      try {
        setLoading(true);
        const user = await getLoginUserData();
        setLoggedInUserId(user.id);
        if (user?.id) setBankerId(user.id);
      } catch {
        console.error("Failed to load user data");
      }finally {
        setLoading(false);
      }
    };
    init();
  }, []);

  if (loading) return <Loader />;
  return (
    <div className={`flex justify-center items-start ${isMobile ? 'px-4' : ''}`}>
      <Paper elevation={4} className={`w-full rounded-2xl shadow-md ${isMobile ? 'p-4' : 'p-6'}`}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant={isMobile ? 'scrollable' : 'fullWidth'}
          centered={!isMobile}
          sx={{
            borderRadius: "12px",
            backgroundColor: theme.palette.grey[100],
            mb: isMobile ? 1 : 2,
            "& .MuiTabs-indicator": {
              height: "3px",
              borderRadius: "3px",
            },
          }}
        >
          <Tab
            icon={<AccountCircleIcon />}
            iconPosition="start"
            label={isMobile ? '' : 'Update Profile'}
            sx={{
              fontWeight: 600,
              color: activeTab === 0 ? theme.palette.primary.main : "inherit",
              transition: "all 0.3s",
            }}
          />
          <Tab
            icon={<LockResetIcon />}
            iconPosition="start"
            label={isMobile ? '' : 'Change Password'}
            sx={{
              fontWeight: 600,
              color: activeTab === 1 ? theme.palette.primary.main : "inherit",
              transition: "all 0.3s",
            }}
          />
        </Tabs>
        
        <Box className={`transition-all duration-300 ease-in-out ${isMobile ? 'mt-4' : 'mt-6'}`}>
          {activeTab === 0 && <BankerAccount bankerId={bankerId} loggedInUserId={loggedInUserId || ""}/>}
          {activeTab === 1 && <BankerChangePassword bankerId={bankerId}/>}
        </Box>
      </Paper>
    </div>
  );
};

export default BankerProfile;
